export const baseTooltipStyle: React.CSSProperties = {
  textAlign: 'center',
  letterSpacing: '0px',
  color: '#525252',
  background: '#FFFFFF 0% 0% no-repeat padding-box',
  boxShadow: '0px 3px 16px #00000029',
  wordBreak: 'break-all',
  overflowWrap: 'break-word',
};
